"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconLogs = function SvgIconLogs(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "logs icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Logs Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M10.316 4.073h27.368C41.18 4.073 44 6.884 44 10.366v18.878c0 3.482-2.821 6.292-6.316 6.292h-9.663l-7.79 7.782a2.103 2.103 0 01-1.494.609 2.108 2.108 0 01-2.105-2.098v-6.293h-6.316C6.82 35.536 4 32.726 4 29.244V10.366c0-3.482 2.821-6.293 6.316-6.293zm27.368 2.098H10.316c-2.316 0-4.21 1.888-4.21 4.195v18.878c0 2.307 1.894 4.195 4.21 4.195h8.42v8.39l8.422-8.39h10.526c2.316 0 4.21-1.888 4.21-4.195V10.366c0-2.307-1.894-4.195-4.21-4.195zm-27.368 6.293h27.368v2.097H10.316zm0 6.292h25.263v2.098H10.316zm0 6.293h16.842v2.097H10.316z"
  }));
};

var _default = SvgIconLogs;
exports.default = _default;